module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Hits")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Game Totals")]), _vm._v(" "), _c('chart', {
    ref: "apex_hit_chart",
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.apex_hit_options,
      "series": _vm.apex_hit_series
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3d17f50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/match-hits.vue
// module id = 649
// module chunks = 30